import { GetStaticProps } from 'next'

import { convertToComponent } from '@ecm/data/Contentful'
import { Snippet } from '@ecm/data/Snippet'
import { runEff } from '@ecm/effect'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

type TermsOfServicePageProps = {
  terms: Snippet
}

const TermsOfServicePage = ({ terms }: TermsOfServicePageProps) => (
  <DefaultLayout hideFinalCta seoPage="terms-of-service">
    <PlainHeader title="Terms of Service" />
    <MainContainer sx={{ paddingY: '4em' }}>
      {terms && convertToComponent(terms.content, 'p3')}
    </MainContainer>
  </DefaultLayout>
)

export default TermsOfServicePage

export const getStaticProps: GetStaticProps = async () => {
  const terms = await runEff(eff => eff.getSnippet('terms-of-service'))

  return { props: { terms } }
}
